import React, { useState } from "react";
import { Modal, ModalBody } from "reactstrap";
import { cancelEvent } from "../../../../actions/admin/scheduled-event-actions";
import { connect } from "react-redux";
import Loader from "../../../../components/Loader/Loader";
import { notification, gotProperty } from "../../../../utils/utility";
import { sendPostRequest } from "../../../../actions/app-actions";
import { formatBookingDate } from "./formatBookingDate";
import "./scheduledEvents.scss";

const UpcomingCancelModal = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [reason, setReason] = useState("");

  /**
   * on cancel event
   */
  const onCancel = () => {
    const {
      cancelEvent,
      handleClose,
      handleViewDetailClose,
      loadUpcomingEvents,
      isBulk,
      isStaffCancellation,
      sendPostRequest,
      data,
    } = props;
    setIsLoading(true);
    if (isBulk) {
      sendPostRequest({
        url: `/booking/bulk-cancel`,
        data: {
          ids: data,
          booking_status: "CS",
          cancellation_reason: reason,
        },
        onSuccess: function () {
          setIsLoading(false);
          notification.success("Events successfully cancelled");
          handleClose();
          loadUpcomingEvents();
        },
        onError: function (error) {
          console.log("error", error);
          setIsLoading(false);
          notification.error("Could not cancel these events. Please try again.");
        },
      });
    } else {
      cancelEvent({
        data: {
          booking_id: props.data.id,
          cancellation_reason: reason,
          booking_status: "CS",
          is_cancelled_by_staff: isStaffCancellation ? "E" : "D",
        },
        onSuccess: function () {
          setIsLoading(false);
          notification.success("Event is successfully canceled");
          handleClose();
          if (typeof handleViewDetailClose === "function") {
            handleViewDetailClose();
          }
          if (typeof loadUpcomingEvents === "function") {
            loadUpcomingEvents();
          }
        },
        onError: function (error) {
          console.error(error);
          setIsLoading(false);
          notification.error("Could not cancel this event. Please try again.");
        },
      });
    }
  };

  const whenLabel =
    !props.isBulk && props.data && gotProperty(props.data, "when")
      ? [
          formatBookingDate(props.data.when, "DD-MM-YYYY"),
          props.data.start_time && props.data.end_time
            ? `${props.data.start_time} – ${props.data.end_time}`
            : null,
        ]
          .filter(Boolean)
          .join(" ")
      : "";

  return (
    <>
      <Loader isShowLoader={isLoading} />
      <Modal
        isOpen={Boolean(props.showCancelModal)}
        toggle={props.handleClose}
        centered
        className="se-details-modal"
        contentClassName="se-details-modal__content"
      >
        <ModalBody>
          <div className="se-details">
            <header className="se-details__header">
              <div className="se-details__header-copy">
                <p className="se-details__eyebrow">Cancel booking</p>
                <h2>{props.isBulk ? "Cancel selected events" : "Cancel event"}</h2>
                {whenLabel ? (
                  <span className="se-details__slot">{whenLabel}</span>
                ) : null}
              </div>
              <button
                type="button"
                className="se-details__close"
                onClick={props.handleClose}
                aria-label="Close"
              >
                ×
              </button>
            </header>

            {!props.isBulk && props.data?.invitee ? (
              <p className="se-confirm__copy">
                Invitee: <strong>{props.data.invitee}</strong>
              </p>
            ) : null}

            <p className="se-confirm__copy">
              Please confirm that you would like to cancel this event. A
              cancellation email will also go out to the invitee.
            </p>

            <label className="se-cancel-reason" htmlFor="cancel-reason">
              Reason
              <textarea
                id="cancel-reason"
                name="reason"
                placeholder="Optional reason for the invitee"
                value={reason}
                onChange={({ target }) => setReason(target.value)}
              />
            </label>

              <div className="se-details__actions">
                <button
                  type="button"
                  className="se-btn se-btn--ghost"
                  onClick={props.handleClose}
                >
                  {props.isBulk ? "Keep events" : "Keep booking"}
                </button>
              <button
                type="button"
                className="se-btn se-btn--danger"
                onClick={onCancel}
                disabled={isLoading}
              >
                Yes, cancel
              </button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default connect(null, {
  cancelEvent,
  sendPostRequest,
})(UpcomingCancelModal);
